import Accordion from "react-bootstrap/Accordion";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LogoVidaPremiada from "../../assets/images/vida-premiada.png";
import "./Duvidas.css";

export default function Duvidas() {
  return (
    <Container>
      <Row id="duvidas">
        <Col className="title-col">
          <h2 className="section-title">DÚVIDAS FREQUENTES</h2>
        </Col>
      </Row>
      <Row>
        <Accordion defaultActiveKey={["0"]} alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              Quem pode participar da promoção?
            </Accordion.Header>
            <Accordion.Body>
              <p>Associados que pagarem suas mensalidades em dia.</p>
              <p>
                Novos associados que aderirem ao Plano Assistencial Grupo Krause
                durante a promoção.
              </p>
              <p>
                Todos os planos assistenciais sob responsabilidade da Krause
                Assistencial Ltda, exceto o Serviço Planejado e os planos
                Empresarial e Empresarial Krause.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              Quem não pode participar da promoção?
            </Accordion.Header>
            <Accordion.Body>
              <p>Clientes da Funerária Krause e do Memorial Krause.</p>
              <p>Funcionários e diretores do Grupo Krause.</p>
              <p>
                Funcionários das empresas fornecedoras envolvidas na promoção.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              Preciso fazer algum tipo de inscrição para concorrer?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Não, basta ter um plano assistencial ativo e pagá-lo em dia.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              Qual é o período de participação da campanha?
            </Accordion.Header>
            <Accordion.Body>
              <p>01/02/2026 a 31/12/2026</p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
            <Accordion.Header>Quais são os prêmios?</Accordion.Header>
            <Accordion.Body>
              <p>Serão 11 prêmios no total:</p>
              <p>1 motocicleta 0km da marca Honda modelo CG 160 2026;</p>
              <p>1 Notebook da marca Lenovo modelo Core i3;</p>
              <p>3 TVs da marca AOC modelo Smart 43”;</p>
              <p>
                3 ares-condicionados marca Electrolux modelo JI12R Quente e frio
                12.000 btus;
              </p>
              <p>3 geladeiras marca Consul modelo Frost Free 410 L.</p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5">
            <Accordion.Header>
              Quais são as datas dos sorteios?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Os sorteios mensais vão acontecer nas seguintes e respectivas
                datas:
              </p>
              <p>14/03/2026;</p>
              <p>11/04/2026;</p>
              <p>09/05/2026;</p>
              <p>13/06/2026;</p>
              <p>11/07/2026;</p>
              <p>08/08/2026;</p>
              <p>12/09/2026;</p>
              <p>10/10/2026;</p>
              <p>14/11/2026;</p>
              <p>12/12/2026;</p>
              <p>09/01/2027.</p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="6">
            <Accordion.Header>
              Como posso acumular códigos da sorte?
            </Accordion.Header>
            <Accordion.Body>
              <p>Pagamento em dia: 1 código da sorte.</p>
              <p>
                Novos associados no Plano Assistencial Grupo Krause: 1 código da
                sorte no mês da contratação.
              </p>
              <p>
                Indicação de novos associados: 1 código da sorte por indicação
                efetivada.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="7">
            <Accordion.Header>
              Como sei quantos códigos da sorte eu tenho?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Acesse a central do cliente do Grupo Krause{" "}
                <a
                  className="duvidas-bold"
                  href="https://centraldocliente.grupokrause.com.br/login?redirect=/boletos"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  clicando aqui
                </a>{" "}
                e verifique seus códigos até 10 dias antes de cada sorteio.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="8">
            <Accordion.Header>
              Quando e como os ganhadores serão notificados?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Os nomes e códigos contemplados serão divulgados nesse site e em
                nossas redes sociais após a confirmação.
              </p>
              <p>
                A empresa irá localizar o contemplado através dos meios de
                contato de cadastro.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="9">
            <Accordion.Header>
              Se eu ganhar, como vou receber o prêmio?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                O prêmio será entregue em até 30 dias após a data de apuração.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="10">
            <Accordion.Header>
              O que pode me desclassificar da promoção?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Estar inadimplente em qualquer obrigação financeira na data de
                apuração do sorteio.
              </p>
              <p>
                Estar com o plano assistencial cancelado na data do sorteio.
              </p>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Row>
      <Row id="regulamento">
        <img
          src={LogoVidaPremiada}
          alt="Logo Vida Premiada"
          className="logo-vida-premiada"
        />
      </Row>
      <Row>
        <p className="duvidas-text">
          Faça seu plano agora mesmo e concorra a{" "}
          <span>prêmios da Vida Premiada Krause.</span>
        </p>
      </Row>
      <Row>
        <Col className="primary-btn-col">
          <a
            href="/vida-premiada-regulamento-2026.pdf"
            rel="noopener noreferrer"
            target="_blank"
            className="primary-btn"
          >
            ACESSAR REGULAMENTO
          </a>
        </Col>
      </Row>
    </Container>
  );
}
